import type { CampaignQaPusherChunk } from "@dashboardApi/apis/generativeAiAppGroupIdCampaignQa/chunkedMerge";
import { mergeCampaignQaPusherChunks } from "@dashboardApi/apis/generativeAiAppGroupIdCampaignQa/chunkedMerge";

import { registerChunkedMergeStrategy } from "../../reactQueryFetcherAdapters/utils/chunkedPusherMerge";

let registered = false;

/**
 * Registers the "canvasQa" chunked merge strategy with the generic POSTWS
 * chunked-delivery layer.
 *
 * The chunk shape and reassembly are identical to Campaign QA's — chunks are
 * sorted by chunk_index and grouped by agent — so this reuses
 * mergeCampaignQaPusherChunks rather than duplicating it. Canvas step results
 * repeat a ruleset name across steps, but the backend already gives each step
 * its own chunk (CampaignQaPusherDelivery keys on [step_id, ruleset_name]), so
 * concatenation preserves them; the per-step distinction is re-established at
 * render time by the caller's groupKey.
 *
 * It is registered under its own name rather than reusing "campaignQa" because
 * the strategy name is part of the endpoint's typed props, and keeping them
 * separate leaves room to diverge without touching Campaign.
 *
 * Call at the top of any hook body that passes `chunkedMerge: "canvasQa"` —
 * the idempotent guard makes repeated calls free.
 */
export function registerCanvasQaChunkedMerge(): void {
  if (registered) {
    return;
  }
  registered = true;

  registerChunkedMergeStrategy<CampaignQaPusherChunk, unknown>("canvasQa", {
    completionKey: "chunked_result_complete",
    merge(envelope, chunks) {
      return {
        ...envelope,
        agent_results: mergeCampaignQaPusherChunks(chunks),
      };
    },
  });
}
